<template>
  <SectionContainer class="content">
    <h3>Que tal adquirir o conhecimento para alcançar seus objetivos?</h3>
    <StartNowButton />
  </SectionContainer>
</template>

<script>
  import SectionContainer from '@/components/layout/SectionContainer'
  import StartNowButton from '@/components/buttons/StartNowButton'

  export default {
    components: {
      SectionContainer,
      StartNowButton,
    }
  }
</script>

<style scoped lang="scss">
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-right: 15px;
    padding-left: 15px;
    max-width: 800px;

    picture {
      margin-bottom: 30px;
    }

    h3 {
      text-align: center;
      margin-bottom: 30px;
    }
  }
</style>